app.namespace('effects');

app.effects = (function ($) {    
    function init() {
    	// add glitch stuff here
    }

    return {
        init: init
    };
}(jQuery));